'use client';

import { useInitializeBackend } from '@/stores/backendStore';

/**
 * Component that initializes the backend store.
 * Should be placed near the root of the application.
 */
export function BackendStoreInitializer() {
  useInitializeBackend();
  return null;
}
